import {NativeDateAdapter} from '@angular/material/core';
import {Inject, Injectable, LOCALE_ID, PLATFORM_ID} from '@angular/core';
import {Platform} from '@angular/cdk/platform';
import {getLocaleFirstDayOfWeek} from '@angular/common';

@Injectable({providedIn: 'root'})
export class LocaleDateAdapter extends NativeDateAdapter {

  constructor(
    @Inject(LOCALE_ID) locale: string,
    @Inject(PLATFORM_ID) platformId: Platform,
  ) {
    super(locale, platformId);
  }

  getFirstDayOfWeek(): number {
    return getLocaleFirstDayOfWeek(this.locale);
  }

  parse(value: any): Date | null {
    if (typeof value === `string` && 7 <= value.length && value.length <= 10) {
      const parts = value.split(`.`);
      if (parts.length === 3) {
        return new Date(+parts[2], (+parts[1]) - 1, +parts[0]);
      }
    }
    return super.parse(value);
  }

}
